<template>
    <div class="bg">
        <div class="co">
            <div class="kv">
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/score/kv.png">
            </div>
            <div class="panel">
                <div class="title">
                    <span>专家评分</span>
                </div>
                <div class="hint" @click="showPopup">
                    <span class="question"></span>
                    <span>评分规则</span>
                </div>
                <div class="content">
                    <div class="rule">
                        <fieldset>
                            <legend>温馨提示</legend>
                            <div class="item">
                                <span class="icon icon-1"></span>
                                请给所有选手评分
                            </div>
                            <div class="item">
                                <span class="icon icon-2"></span>
                                最高分为100分
                            </div>
                            <div class="item">
                                <span class="icon icon-3"></span>
                                <span>评分标准</span>
                                <span style="color: #197F54" @click="extend=!extend" v-if="extend==0"> >>详情 </span>
                                <span style="color: #197F54" @click="extend=!extend" v-if="extend==1"> >>收起 </span>
                            </div>
                            <div style="width: 100%;" v-if="extend==1">
                                <img  src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/score/score-standard-2.png" style="width: 100%;height: auto;border: none;padding: 0">
                            </div>
                        </fieldset>
                    </div>
                    <div class="info-item"  v-for="(item,i) in players" v-bind:key="i">
                        <div class="avatar">
                            <img :src="item.avatar">
                        </div>
                        <div class="info">
                            <span>{{item.name}}</span>
                            <span>{{item.hos}}</span>
                        </div>
                        <div class="score">
                            <input type="number" readonly @click="toScore(i)" v-model="item.score">
                            <span>分</span>
                        </div>
                    </div>
                </div>
                <mt-popup class="popup" v-model="scorePopupVisible" popup-transition="popup-fade" closeOnClickModal="true" position="bottom">
                    <mt-picker :slots="scoreSlots" @change="scoreValuesChange" showToolbar>
                        <div class="picker-toolbar-title">
                            <div class="usi-btn-cancel" @click="scorePopupVisible = !scorePopupVisible">取消</div>
                            <div class="">请选择分数</div>
                            <div class="usi-btn-sure" @click="scoreValueAdd">确定</div>
                        </div>
                    </mt-picker>
                </mt-popup>
            </div>
        </div>
        <div style="width: 100%;height: 100vh;">
            <MyPopup ref="myPopup" :data="data" :title="title"></MyPopup>
        </div>
    </div>
</template>

<script>
    import MyPopup from "@/components/plugins/popup/MyPopup";
    import {cdqiPlayerListByExpert,cdqiExpertScore} from "@/assets/js/api";

    export default {
        name: "PlayerScore",
        components:{
          MyPopup
        },
        data(){
            return{
                extend:0,
                players:[],
                scorePopupVisible:false,
                scoreSlots: [{
                    values: [],
                }],
                scoreSure:"",
                scoreIndex:0,
                maxScore:100,
                index:0,
                data:["1、分别由专家打分和观众打分，专家占比95%，观众占比5%","2、专家通过打分表进行打分，观众通过直播端的【选手评分】菜单中进行打分","3、观众只能在选手演讲及点评时间段内进行打分"],
                title:"专家评分规则",
                expertId: this.$route.query.expertId,
                websock:null
            }
        },
        methods:{
            toScore(index){
                // if(this.players[index].status==0){
                //     this.$toast("选手当前不可打分");
                //     return
                // }
                this.scoreSlots[0].values=[]
                for(let i=this.maxScore;i>=1;i--){
                    this.scoreSlots[0].values.push(i)
                }
                this.index = index
                console.log("index="+index)
                this.scorePopupVisible = true
            },
            scoreValuesChange(picker, values) {
                this.scoreSure = values[0];
            },
            scoreValueAdd(){
                this.scorePopupVisible = !this.scorePopupVisible
                this.players[this.index].score=this.scoreSure
                this.toSubmit(this.expertId,this.scoreSure,this.players[this.index].player_id)
            },
            async toSubmit(expertId,score,playerId){
                const res = await cdqiExpertScore({expertId,playerId,score})
                if(res.data.success){
                    this.$toast("打分成功")
                }else{
                    this.$toast(res.data.message)
                }
            },
            showPopup(){
                // this.$toast("show popup!!!!")
                this.$refs.myPopup.popupShow=true
            },
            async playerList(expertId){
                const res = await cdqiPlayerListByExpert({expertId})
                this.players = res.data.data
            },
            initWebSocket: function () {
                this.websock = new WebSocket("ws://server.iumed.com.cn/plus/one/websocket");
                // this.websock = new WebSocket("ws://192.168.2.120:9090/one/websocket");
                this.websock.onopen = this.websocketonopen;
                this.websock.onerror = this.websocketonerror;
                this.websock.onmessage = this.websocketonmessage;
                this.websock.onclose = this.websocketclose;
                console.log("--------websocketc初始化-------")
            },
            websocketonmessage: function (e) {
                console.log("----signal coming----",e.data)
                // var da =e.data;
                this.playerList(this.expertId);
            },
        },
        mounted(){
            if(this.expertId==null){
                this.$router.replace("/hz/jl")
                return;
            }
            this.playerList(this.expertId);
            this.initWebSocket()
        }
    }
</script>

<style scoped lang="scss">
    .bg{
        width: 100%;
        height: 100vh;
        background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/score/bg-2.png") no-repeat;
        background-size: 100% 100%;
        overflow: scroll;
        position: relative;
    }
    .co{
        position: absolute;
    }
    .kv{
        width: 100%;
        img{
            width: 100%;
            height: auto;
            margin-top: 10px;
        }
    }
    .panel{
        background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/score/panel.png") no-repeat;
        background-size: 100% 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: absolute;
    }
    .panel .title{
        margin-top: 3%;
        width: 100%;
        height: 20px;
        font-size: 14px;
        color: #FFF
    }

    .panel .hint{
        position: absolute;
        right: 4%;
        top: 2%;
        font-weight: bold;
        font-size: 11px;
        text-align: right;
        display: flex;
        align-items: center;
        color: #FFF;
    }
    .question{
        width: 12px;
        height: 12px;
        background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/score/question-circle.png") no-repeat;
        background-size: 100% 100%;
        display: inline-block;margin-right: 3px;
    }
    .content{
        flex-grow: 1;
        background: #FFF;
        width: 96%;
        margin-top: 4%;
        margin-bottom: 1%;
        border-radius: 10px;
        overflow: scroll;
    }
    .rule{
        margin: 5px;
        text-align: left;
        font-size: 12px;
        color: #000;
        fieldset{
            border: 1px #c5c5c5 solid;
            border-radius: 5px;
            .item{
                margin-bottom: 4px;
            }
        }
        legend{
            background: rgb(25,127,84);
            color: #FFF;
            font-size: 14px;
            border-radius: 5px;
            padding: 3px 8px;
        }
    }

    .info-item{
        display: flex;
        flex-direction: row;
        padding: 5px 0;
        /*border-bottom: 1px solid #e5e5e5;*/
        background:#e5f2e0;
        margin-bottom: 2px;
        .avatar{
            margin: 0 20px 0 10px;
            img{
                width: 70px;
                height: 70px;
                border-radius: 50%;
            }
        }
        .info{
            display: flex;
            flex-flow: column nowrap;
            justify-content: center;
            font-size: 14px;
            flex-grow: 1;
            span{
                display: block;
                text-align: left;
                margin-bottom: 2px;
            }
            span:first-child{
                font-weight: bold;
            }
        }
        .score{
            display: flex;
            align-items: flex-end;
            margin-bottom: 10px;
            margin-right: 10px;
            input{
                outline: none;
                border: none;
                border-radius: 0;
                border-bottom: 1px #197F54 solid;
                width: 45px;
                font-size: 22px;
                color: red;
                font-weight: bold;
                text-align: right;
                background: transparent;
                -webkit-user-select :none;  /* readonly 在苹果浏览器上不起作用*/
            }
            span{
                color: red;
                margin-left: 1px;
                font-size: 12px;
            }
        }
    }

    .picker-toolbar-title {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
    }

    .usi-btn-cancel,
    .usi-btn-sure {
        color: #197F54;
    }

    .popup{
        width: 100%;
    }

    .item{
        display: flex;
        align-items: center;
        text-align: left;
        font-size: 12px;
    }
    .icon{
        width: 18px;
        height: 18px;
        display: inline-block;
        margin: 0 5px;
    }
    .icon-1{
        background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/score/icon-1.png") no-repeat;
        background-size: 100% 100%;
    }
    .icon-2{
        background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/score/icon-2.png") no-repeat;
        background-size: 100%;
    }
    .icon-3{
        background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/score/icon-3.png") no-repeat;
        background-size: 100%;
    }
    .info-item-disable{
        background: #d3d2d2;
    }

</style>